"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Anushavan.Hovsepyan
 * Updated by Tatevik.Marikyan
 * on 10/4/2016.
 */
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var service_1 = require("../../shared/api/service");
var abstract_destruction_subject_1 = require("../../shared/utilities/abstract-destruction-subject");
require("./sis-audit-trail.component.scss");
/**
 * AuditTrailComponent component.
 * Gets as input:
 *      systemName - The unique identifier for entity.
 *      instanceId - An identity of the instance to be fetched.
 *      tableColumnFields - Object containing table column title and property name.
 *      pageLimit - The limit (or number of items) of data to be fetched.
 */
var AuditTrailComponent = /** @class */ (function (_super) {
    __extends(AuditTrailComponent, _super);
    function AuditTrailComponent(_deService, _httpClient, _applicationPropertiesService) {
        var _this = _super.call(this) || this;
        _this._deService = _deService;
        _this._httpClient = _httpClient;
        _this._applicationPropertiesService = _applicationPropertiesService;
        /**
         * Page limit of history.
         * @type {number}
         */
        _this.pageLimit = 5;
        _this.DATE_UPDATED_SYSTEM_NAME = 'DateUpdated';
        _this.USER_UPDATED_SYSTEM_NAME = 'UpdatedUserID';
        _this.DE_SERVICE_URI_KEY = 'de-service-url';
        /*tslint:disable:max-line-length*/
        _this.URL_ENTITY_DIFF = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/entity/diff/", "/", "/", "?formId=", "&"], ["", "/entity/diff/", "/", "/", "?formId=", "&"])), 'response', 'systemName', 'oldVersion', 'newVersion', 'formId');
        /*tslint:enable:max-line-length*/
        /**
         * Current page of table.
         * @type {number}
         * @private
         */
        _this._currentPage = 0;
        /**
         * Array of selected history versions.
         * @type {Entity[]}
         * @private
         */
        _this._selectedVersions = [];
        /**
         * Shows if the version selection checkboxes are enabled/disabled.
         * @type {boolean}
         * @private
         */
        _this._isCheckboxesDisabled = false;
        /**
         * Warning popup activate flag
         * @type {boolean}
         * @private
         */
        _this._isWarningPopupActive = false;
        return _this;
    }
    Object.defineProperty(AuditTrailComponent.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        set: function (currentPage) {
            this._currentPage = currentPage;
            var startIndex = this._currentPage * this.pageLimit;
            this._loadItems(new idm_de_core_frontend_1.PagingOptions(startIndex, this.pageLimit));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditTrailComponent.prototype, "totalVersionsCount", {
        get: function () {
            return this._totalVersionsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditTrailComponent.prototype, "versions", {
        get: function () {
            return this._versions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditTrailComponent.prototype, "totalPagesCount", {
        get: function () {
            return this._totalPagesCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditTrailComponent.prototype, "isCheckboxesDisabled", {
        get: function () {
            return this._isCheckboxesDisabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditTrailComponent.prototype, "isWarningPopupActive", {
        get: function () {
            return this._isWarningPopupActive;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Checks the changes and calls corresponding method to handle the change
     * @param {SimpleChange} changes
     * @returns {void}
     * @public
     * @method
     */
    AuditTrailComponent.prototype.ngOnChanges = function (changes) {
        if (changes.identityId) {
            this._loadItems(new idm_de_core_frontend_1.PagingOptions(0, this.pageLimit), new idm_de_core_frontend_1.SortingOptions(this.DATE_UPDATED_SYSTEM_NAME, idm_de_core_frontend_1.SortType.DESC));
        }
    };
    AuditTrailComponent.prototype.setWarningPopupActive = function (isWarningPopupActive) {
        if (this._isWarningPopupActive !== isWarningPopupActive) {
            this._isWarningPopupActive = isWarningPopupActive;
            if (this.warningPopup) {
                if (isWarningPopupActive) {
                    this.warningPopup.open();
                }
                else {
                    this.warningPopup.close();
                }
            }
        }
    };
    /**
     * Selects/deselects version and disables checkboxes if it is necessary.
     * @param {any} checkBox - Clicked checkbox element.
     * @param {Entity} item
     */
    AuditTrailComponent.prototype.selectVersions = function (checkBox, item) {
        if (checkBox.checked) {
            this._selectedVersions.push({ id: item.getId(), value: item.getProperty(this.DATE_UPDATED_SYSTEM_NAME) });
            if (this._selectedVersions.length === 2) {
                this._isCheckboxesDisabled = true;
            }
        }
        else {
            this._selectedVersions = this._selectedVersions.filter(function (version) { return version.id !== item.getId(); });
            this._isCheckboxesDisabled = false;
        }
    };
    /**
     * Compares selected two versions. If selected versions count less than two shows the warning message.
     */
    AuditTrailComponent.prototype.compareVersions = function () {
        var _this = this;
        if (this._selectedVersions.length === 2) {
            var windowName = 'Versions comparison';
            var params = 'height=700,width=1500';
            var oldVersion_1 = this._selectedVersions[0].id > this._selectedVersions[1].id
                ? this._selectedVersions[1] : this._selectedVersions[0];
            var newVersion_1 = this._selectedVersions[0].id < this._selectedVersions[1].id
                ? this._selectedVersions[1] : this._selectedVersions[0];
            this.renderOptions.oldHeader = this.formatDateFunction(oldVersion_1.value.value);
            this.renderOptions.newHeader = this.formatDateFunction(newVersion_1.value.value);
            var httpParams_1 = new http_1.HttpParams();
            var queryParams = [];
            queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', this.currentLanguageId));
            queryParams.push(new idm_de_core_frontend_1.SearchParam('renderOptions', this.renderOptions));
            if (this.ignoredFields) {
                queryParams.push(new idm_de_core_frontend_1.SearchParam('ignoredFields', this.ignoredFields));
            }
            queryParams.forEach(function (searchParam) {
                var value = typeof searchParam.getValue() !== 'object'
                    ? searchParam.getValue() : JSON.stringify(searchParam.getValue());
                httpParams_1 = httpParams_1.set(searchParam.getName(), value);
            });
            var requestOptions_1 = { headers: null, params: httpParams_1 };
            var comparisonWindow_1 = window.open('', windowName, params);
            this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)
                .then(function (response) {
                var url = _this.URL_ENTITY_DIFF.replaceTemplate({
                    formId: _this.formId,
                    newVersion: newVersion_1.id.toString(),
                    oldVersion: oldVersion_1.id.toString(),
                    response: response,
                    systemName: _this.systemName,
                });
                _this._httpClient.get(url, requestOptions_1)
                    .pipe(operators_1.takeUntil(_this.destroySubject$))
                    .subscribe(function (entityDiffResponse) {
                    var body = entityDiffResponse.replace(/\\/g, '');
                    comparisonWindow_1.document.open();
                    comparisonWindow_1.document.write(body);
                    comparisonWindow_1.document.close();
                }, function (err) { return console.error(err); });
            });
        }
        else if (this._selectedVersions.length < 2) {
            this.setWarningPopupActive(true);
        }
        else {
            throw new Error('The selected versions can\'t be more than two.');
        }
    };
    AuditTrailComponent.prototype.getUserFullName = function (user) {
        return user.getProperty('FIRSTNAME').value + ' ' + user.getProperty('LASTNAME').value;
    };
    AuditTrailComponent.prototype.trackByFunc = function (index, entity) {
        return entity.getId();
    };
    /**
     * Checks if the item is selected or not from corresponding list.
     * @param {Entity} item - the item which we want to know is Selected or not .
     */
    AuditTrailComponent.prototype.isItemSelected = function (item) {
        return this._selectedVersions.some(function (version) {
            return version.id === item.getId();
        });
    };
    /**
     * Loads entity history.
     * @param {PagingOptions} pagingOptions - The pagingOptions to serve entity history in accordance.
     * @param {SortingOptions} sortingOptions - The sortingOptions to serve entity history in accordance.
     */
    AuditTrailComponent.prototype._loadItems = function (pagingOptions, sortingOptions) {
        var _this = this;
        if (!sortingOptions) {
            sortingOptions = new idm_de_core_frontend_1.SortingOptions(this.DATE_UPDATED_SYSTEM_NAME, idm_de_core_frontend_1.SortType.DESC);
        }
        var loadableMetaFields = [
            this.identitySystemName,
            this.DATE_UPDATED_SYSTEM_NAME,
            this.USER_UPDATED_SYSTEM_NAME,
            this.wfStateSystemName !== undefined && this.wfStateSystemName,
        ].filter(Boolean);
        this._deService
            .loadHistoricalEntityItems(this.systemName, this.instanceId, pagingOptions, sortingOptions, loadableMetaFields)
            .pipe(operators_1.first())
            .subscribe(function (response) {
            _this._versions = response.getData();
            _this._totalVersionsCount = response.getMeta().getTotalRowCount();
            _this._totalPagesCount = Math.ceil(_this._totalVersionsCount / _this.pageLimit);
            // this._sortVersions();
        }, function (err) { return console.error(err); });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AuditTrailComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AuditTrailComponent.prototype, "systemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], AuditTrailComponent.prototype, "identityId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], AuditTrailComponent.prototype, "instanceId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], AuditTrailComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AuditTrailComponent.prototype, "identitySystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AuditTrailComponent.prototype, "wfStateSystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], AuditTrailComponent.prototype, "pageLimit", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AuditTrailComponent.prototype, "formId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], AuditTrailComponent.prototype, "renderOptions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], AuditTrailComponent.prototype, "ignoredFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AuditTrailComponent.prototype, "warningMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AuditTrailComponent.prototype, "warningTitle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AuditTrailComponent.prototype, "compareButtonMsg", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AuditTrailComponent.prototype, "versionColumnMsg", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], AuditTrailComponent.prototype, "formatDateFunction", void 0);
    __decorate([
        core_1.ViewChild('warningPopup'),
        __metadata("design:type", Object)
    ], AuditTrailComponent.prototype, "warningPopup", void 0);
    AuditTrailComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-audit-trail',
            template: require('./sis-audit-trail.component.html'),
        }),
        __metadata("design:paramtypes", [service_1.DeService,
            idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], AuditTrailComponent);
    return AuditTrailComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.AuditTrailComponent = AuditTrailComponent;
var templateObject_1;
//# sourceMappingURL=sis-audit-trail.component.js.map